import { createStore } from 'satcheljs';
import type RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import type { ProjectId } from 'owa-timestream-store';

export default createStore('timeStreamNewSpaceDialog', {
    isOpen: false,
    isProcessingChanges: false,
    processingError: null as unknown | null,
    nameVisited: false,
    name: '',
    image: '',
    keywords: ['', '', ''],
    peoplePickerViewState: {} as RecipientWellWithFindControlViewState,
    targetMailbox: '',
    editProjectId: null as ProjectId | null,
    projectPreviewId: null as ProjectId | null,
});
